import createClient from "openapi-fetch";
import { env } from "~/env";
import { getRequestHeaders } from "~/lib/utils";
import type { paths } from "./openapispec";

const apiClient = createClient<paths>({
  baseUrl: env.VITE_API_BASE_URL,
  credentials: "include",
});

apiClient.use({
  async onRequest({ request }) {
    const dynamicHeaders = await getRequestHeaders();

    if (dynamicHeaders) {
      Object.entries(dynamicHeaders).forEach(([key, value]) => {
        request.headers.set(key, value);
      });
    }

    return request;
  },
});

export { apiClient };
